<template>
  <div class="contain">
    <div class="colorBox">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="one colorSon" @click="search1('')">
            <p class="p1">全部</p>
            <p class="p2">{{ headInfo.dataAll }}</p>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="two colorSon" @click="search1('0')">
            <p class="p1">进行中</p>
            <p class="p2">{{ headInfo.dataOne }}</p>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="three colorSon" @click="search1('1')">
            <p class="p1">待跟进项目</p>
            <p class="p2">{{ headInfo.dataTwo }}</p>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="four colorSon" @click="search1('2')">
            <p class="p1">协助项目</p>
            <p class="p2">{{ headInfo.dataThree }}</p>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="five colorSon" @click="search1('3')">
            <p class="p1">维护项目</p>
            <p class="p2">{{ headInfo.dataFour }}</p>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="six colorSon" @click="search1('4')">
            <p class="p1">已完成</p>
            <p class="p2">{{ headInfo.dataFive }}</p>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="tableBox">
      <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ background: '#f7f7f7' }">
        <el-table-column label="序号" type="index" align="center">
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="center">
        </el-table-column>
        <el-table-column prop="nodeName" label="节点名称" align="center">
        </el-table-column>
        <el-table-column prop="nodeLeaderName" label="节点负责人" align="center">
        </el-table-column>
        <el-table-column prop="expectFinishTime" label="截止时间" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.expectFinishTime | dataFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createDt" label="分配日期" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createDt | dataFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="finishTime" label="完成日期" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.finishTime !== null">{{
              scope.row.finishTime | dataFormat
            }}</span>
            <span v-if="scope.row.finishTime === null">未完成</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <p style="color: #409eff" @click="openDrawer(scope.row)">操作</p>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.currPage" :page-sizes="[100, 10, 20, 30, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <el-drawer title="" :visible.sync="drawer" :with-header="false" ref="navDrawer">
      <div class="closeIcon" @click="closeDrawer">
        <img src="../../assets/images/close.png" alt="" srcset="" />
      </div>
      <div class="drawerTab">
        <div :class="showtab == 'one' ? 'tab' : 'tab1'" @click="changeTab('one')">
          工作任务
        </div>

        <div :class="showtab == 'two' ? 'tab' : 'tab1'" @click="changeTab('two')">
          项目节点
        </div>
      </div>
      <div class="projectInfo">
        <el-form ref="form" :model="projectInfo" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="项 目 名：">
                <div>{{ projectInfo.projectName }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负 责 部 分：">
                <div>{{ projectInfo.nodeName }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="立项日期：">
                <div>{{ projectInfo.createDt | dataFormatT }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="节点负责人：">
                <div>{{ projectInfo.nodeLeaderName }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="结束日期：">
                <div>{{ projectInfo.expectFinishTime }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="当前节点状态：">
                <el-select :disabled="projectInfo.nodeLeaderCode !== loginName" v-model="projectInfo.nodeStatus"
                  placeholder="请选择节点状态">
                  <el-option v-for="item in nodeStatusList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div v-if="showtab == 'one'">
        <div class="add">
          <el-button type="primary" style="border-radius: 10px;font-size: 15px;" @click="addWork">添加工作结果</el-button>
          <el-button type="danger" @click="openFinish" v-if="projectInfo.nodeLeaderCode === loginName">标记已完成</el-button>
        </div>

        <div class="workList">
          <div class="list" v-for="(item, index) in workList" :key="index">
            <span style="color: #666;">{{ item.createDt | dataFormatT }}</span>
            <span style="white-space: pre-wrap;display: flex;">{{ item.content }}</span>
            <img src="../../assets/images/close.png" style="width: 25px; heigth: 25px" @click="delectList(item.id)" />
          </div>
        </div>
      </div>

      <div class="projectStep" v-if="showtab == 'two'">
        <div>
          <el-button type="primary">项目历程</el-button>
        </div>
        <div class="stepBox">
          <el-steps direction="vertical">
            <el-step v-for="(item, index) in stepList" :key="index" :title="item.expectFinishTime | dataFormatT"
              :description="item.nodeName">
              <template slot="description">
                <span>{{ item.nodeName }} <br />
                  {{ item.nodeLeaderName }} <br />
                  {{ item.leaderRemark }}</span>
              </template>
            </el-step>
          </el-steps>
        </div>
      </div>
    </el-drawer>

    <!-- 添加工作结果 -->
    <el-dialog title="添加工作结果" :visible.sync="dialogVisible" width="735px" class="workDialog">
      <div class="dialogBox">
        <div class="project">
          <p>{{ projectInfo.projectName }}</p>
          <p>{{ gettime }}</p>
        </div>
        <div class="content">
          <div class="box">
            <textarea rows="10" placeholder="请输入内容" v-model="workResult" class="textarea" id="textarea"
              @keydown="handleKeyCode($event)"></textarea>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveProjectNodesLog()">确 定</el-button>
        <el-button @click="cancelSave">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 标记已完成 -->
    <el-dialog title="标记已完成" :visible.sync="finishVisible" width="30%">
      <el-form :model="finishForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="项目状态：" prop="region">
          <el-select v-model="projectStatus" placeholder="请选择活动区域">
            <el-option v-for="item in projectStatusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="节点备注：" prop="desc">
          <el-input type="textarea" v-model="leaderRemark" :rows="6" style="width: 90%"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="finishNode">确 定</el-button>
        <el-button @click="finishVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      drawer: false,
      showtab: "one",
      nodeStatusList: [
        {
          value: "0",
          label: "待处理",
        },
        {
          value: "1",
          label: "待跟进",
        },
        {
          value: "2",
          label: "协助处理",
        },
        {
          value: "3",
          label: "处理中",
        },
        {
          value: "4",
          label: "已完成",
        },
        {
          value: "5",
          label: "挂起",
        },
      ],
      projectStatusList: [
        {
          value: "1",
          label: "需求中",
        },
        {
          value: "2",
          label: "切图中",
        },
        {
          value: "3",
          label: "ui中",
        },
        {
          value: "4",
          label: "开发中",
        },
        {
          value: "5",
          label: "提测",
        },
        {
          value: "6",
          label: "交付中",
        },
        {
          value: "7",
          label: "已交付",
        },
        {
          value: "8",
          label: "挂起",
        },
        {
          value: "9",
          label: "维护",
        },
      ],
      projectStatus: "1",
      form: {},
      dialogVisible: false,
      workResult: "1、",
      queryInfo: {
        currPage: 1,
        pageSize: 100,
        loginName: localStorage.getItem("userName"),
        status: "",
        condition: {},
      },
      total: 0,
      projectInfo: {},
      headInfo: {},
      gettime: null,
      currtime: null,
      workList: [],
      finishVisible: false,
      finishForm: {},
      leaderRemark: "", //节点负责人备注
      stepList: [],
      loginName: "",
      inputList: ['1、']
    };
  },
  created() {
    this.loginName = JSON.parse(localStorage.getItem("loginName")).value;
    console.log(
      "loginName",
      JSON.parse(localStorage.getItem("loginName")).value
    );
    this.getListData();
    this.findHeadData();
  },
  mounted() {
    this.getCurrentTime();
    clearInterval(myTimeDisplay);
    let myTimeDisplay = setInterval(() => {
      this.getCurrentTime(); //每秒更新一次时间
    }, 1000);
  },
  methods: {
    handleKeyCode(event) {
      if (event.keyCode == 13) {
        var index = this.inputList.length + 1;
        console.log('index', index);
        for (let i = index - 1; i > 0; i--) {
          console.log('位置', this.workResult.indexOf(i + '、'));
          // if(this.workResult.indexOf(i+'、') == -1){
          //   this.inputList.pop(this.inputList[i-1])
          // }
        };
        var ind = this.inputList.length + 1;
        this.inputList.push(ind + '、');
        this.workResult = this.workResult + `\n` + ind + '、';
        // this.workResult = this.workResult +  ind + '、';
        event.preventDefault()
      }
    },
    cancelSave() {
      this.dialogVisible = false;
      this.workResult = '1、'
    },
    //条件查询
    search() {
      this.queryInfo.condition = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    // 获取系统时间
    getCurrentTime() {
      //获取当前时间并打印
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      _this.gettime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      _this.currtime = yy + "-" + mm + "-" + dd + " ";
      this.Samplingtime = _this.gettime;
      this.currtime = _this.currtime;
    },
    openDrawer(item) {
      this.drawer = true;
      console.log("--------------------------------");
      console.log("--------------------------------", item);
      this.projectInfo = item;
      this.getWorkList();
      this.getProjectSteps();
    },
    changeTab(type) {
      this.showtab = type;
    },
    // 获取项目流程
    getProjectSteps() {
      let sendData = {};
      sendData.projectCode = this.projectInfo.projectCode;
      this.$http.post("/projectNodes/queryList", sendData).then((res) => {
        console.log("####", res.data.data);
        if (res.data.code == 200) {
          this.stepList = res.data.data;
        }
      });
    },
    // 添加工作结果
    addWork() {
      this.dialogVisible = true;
    },
    // 标记已完成
    openFinish() {
      this.finishVisible = true;
    },
    // 确定标记
    finishNode() {
      let sendData = {};
      sendData.nodeCode = this.projectInfo.nodeCode;
      sendData.leaderRemark = this.leaderRemark;
      sendData.projectStatus = this.projectStatus;
      sendData.nodeStatus = this.projectInfo.nodeStatus;
      this.$http
        .post("/projectNodes/updateProjectNodesStatus", sendData)
        .then((res) => {
          console.log(res.data.data);
          if (res.data.code == 200) {
            this.$notify.success({
              title: "提示",
              message: "标记成功",
              showClose: true,
            });
            this.finishVisible = false;
          } else {
            this.$notify.error({
              title: "提示",
              message: res.data.message,
              showClose: true,
            });
            this.finishVisible = false;
          }
        });
    },
    // 关闭抽屉
    closeDrawer() {
      this.$refs.navDrawer.closeDrawer();
    },
    getListData() {
      // 获取列表
      var that = this;
      that.$http
        .post("/projectNodesMember/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    //保存工作日志
    saveProjectNodesLog() {
      var that = this;
      var data = {
        id: this.projectInfo.id,
        content: this.workResult,
        createorCode: localStorage.getItem("userName"),
        createorName: localStorage.getItem("name"),
      };
      that.$http
        .post("/projectNodesLog/saveProjectNodesLog", data)
        .then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: "提示",
              message: "保存成功",
              showClose: true,
            });
            that.dialogVisible = false;
            that.getWorkList();
            that.workResult = "1、";
          } else {
            that.$notify.error({
              title: "提示",
              message: res.data.message,
              showClose: true,
            });
            that.dialogVisible = false;
          }
        });
    },

    //头部数据查询
    findHeadData() {
      var that = this;
      var data = {
        loginName: localStorage.getItem("userName"),
      };
      that.$http
        .post("/projectNodesLog/findHeadData", data)
        .then(function (response) {
          if (response.data.code == 200) {
            that.headInfo = response.data.data;
          }
        });
    },
    search1(status) {
      this.queryInfo.currPage = 1;
      this.queryInfo.pageSize = 10;
      this.queryInfo.status = status;
      this.getListData();
    },
    // 查询日志记录
    getWorkList() {
      let sendData = {};
      sendData.nodeCode = this.projectInfo.nodeCode;
      sendData.createorCode = JSON.parse(
        localStorage.getItem("loginName")
      ).value;

      let that = this
      this.$http.post("/projectNodesLog/queryList", sendData).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          let diaryData = res.data.data;

          for (let i = 0; i < diaryData.length; i++) {
            let diaryItem = diaryData[i];

            diaryItem.content.replace(/\n/g, '<br>')
          }

          that.workList = diaryData;
        }
      });
    },
    delectList(id) {
      let sendData = {};
      sendData.id = id;
      this.$http.post("/projectNodesLog/delete", sendData).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.$notify.success({
            title: "提示",
            message: "刪除成功",
            showClose: true,
          });
          this.getWorkList();
        } else {
          this.$notify.error({
            title: "提示",
            message: res.data.message,
            showClose: true,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.contain {
  padding: 10px 20px;

  .colorBox {
    .colorSon {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 100px;
      border-radius: 10px;
      color: #fff;

      .p1 {
        font-size: 18px;
      }

      .p2 {
        font-size: 36px;
      }
    }

    .one {
      background-color: #00b5f9;
    }

    .two {
      background-color: #f8ba74;
    }

    .three {
      background-color: #ff6d6d;
    }

    .four {
      background-color: #86d1ee;
    }

    .five {
      background-color: #1cb684;
    }

    .six {
      background-color: #86abee;
    }
  }

  .tableBox {
    margin-top: 40px;
  }

  .closeIcon {
    text-align: right;
    margin: 20px 20px 0 20px;

    img {
      width: 25px;
      height: 25px;
    }
  }

  .drawerTab {
    display: flex;
    justify-content: space-between;
    margin: 10px 20px 20px 20px;
    gap: 10px;

    .tab {
      // border: 1px solid #1d9fff;
      border-radius: 10px;
      background-color: #1d9fff;
      color: #fff;
      width: 250px;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }

    .tab1 {
      border: 1px solid #1d9fff;
      box-sizing: border-box;
      border-radius: 10px;
      // background-color: #1d9fff;
      color: #1d9fff;
      width: 250px;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
  }

  .projectInfo {
    margin: 0 20px;
    background-color: #f5f5f5;
    padding: 10px;
  }

  .add {
    margin: 20px;
    display: flex;
    justify-content: space-between;

    /deep/.el-button {
      height: 40px;
      line-height: 40px;
    }
  }

  .workList {
    margin: 20px;

    .list {
      position: relative;
      border: 1px solid #efefef;
      border-radius: 5px;
      padding: 15px 15px;
      box-sizing: border-box;
      margin-top: 20px;

      p {
        word-wrap: break-word;
        word-break: break-all;
        font-size: 14px;
      }

      img {
        position: absolute;
        top: -10px;
        right: -10px;
      }
    }
  }

  .projectStep {
    margin: 20px;

    .stepBox {
      margin-top: 10px;
    }

    /deep/.el-button {
      height: 40px;
      line-height: 40px;
    }

    /deep/.el-step__head.is-wait {
      color: #409eff;
      border-color: #409eff;
    }

    /deep/.el-step__title.is-wait {
      color: #000;
    }

    /deep/.el-step__description.is-wait {
      color: #000;
    }

    /deep/.el-step__line {
      background-color: #409eff;
    }
  }

  /deep/.el-dialog__header {
    background-color: #fff;
    padding: 10px;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    text-align: center;
  }

  /deep/.el-dialog__header .el-dialog__title {
    line-height: 20px;
    font-size: 16px;
    color: #000;
  }

  /deep/.el-dialog__footer {
    text-align: center;
  }

  .workDialog {
    .dialogBox {
      padding: 0 20px;
      border: 5px solid #000;
      border-image-source: url(../../assets/images/border.png);
      border-image-slice: 20 0 20 0;
      background-color: transparent;

      .project {
        display: flex;
        justify-content: space-around;
      }

      .content {
        position: relative;
        overflow: hidden;
        box-sizing: border-box;
        background-color: transparent;

        .box {
          height: 340px;

          .textarea {
            position: absolute;
            padding-top: 5px;
            width: 100%;
            box-sizing: border-box;
            background-color: transparent;
            border: 0;
            outline: none;
            display: block;
            line-height: 32px;
            font-size: 15px;
            z-index: 2;
          }
        }
      }

      .content:before {
        position: absolute;
        content: "____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A";
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        color: silver;
        line-height: 1.6;
        font-size: 20px;
      }
    }
  }
}
</style>